import { http } from '@/services';

export default {
  getTestList: async function() {
    try {
      return await http.get('teste/');
    } catch (e) {
      return e.response.data;
    }
  },
  getTest: async function(testId){
    try{
      return await http.get(`teste/${testId}`);
    }catch(e){
      return e.response.data
    }
  },
  createTest: async function(newTest) {
    try {
      return await http.post('teste/', newTest);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteTest: async function(testId) {
    try {
      return await http.delete(`teste/${testId}`); 
    } catch (e) {
      console.log(e)
      return e.response.data;
    }
  },
  updateTest: async function (test){
    try{
      return await http.put(`teste/`, test);
    }catch(e){
      return e
    }
  }
};
